import { render } from "./ParentClientListing.vue?vue&type=template&id=4aa6c10a&scoped=true"
import script from "./ParentClientListing.vue?vue&type=script&lang=js"
export * from "./ParentClientListing.vue?vue&type=script&lang=js"

import "./ParentClientListing.vue?vue&type=style&index=0&id=4aa6c10a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa6c10a"]])

export default __exports__